var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`mc-badge ${_vm.computedVariant} ${_vm.computedSize} ${_vm.computedType}`,style:(_vm.computedStyle)},[(_vm.icon)?_c('i',{class:`${_vm.icon} ${_vm.computedIconVariant} mc-badge-icon`}):_vm._e(),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }